/* eslint-disable */
<template>
    <v-layout>
        <v-dialog v-model="batchTypes.dialog" persistent scrollable width="30%">
            <v-card>
                <v-toolbar color="primary">
                  <v-toolbar-title style="color: white">
                    {{$t('app.batchtypes')}}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field v-model="search" clearable dark hide-details append-icon="mdi-magnify" single-line></v-text-field>
                </v-toolbar>
                <v-card-text style="max-height: 500px;">
                    <v-list two-line>
                        <v-list-item-group v-model="selectedIndex" active-class="blue--text">
                            <template v-for="(item, index) in items">
                                <v-list-item :key="item.Id" @click="changeType(item)" :disabled="disableItem">
                                    <template v-slot:default="{ active }">
                                    <v-list-item-content>
                                        <v-list-item-title v-text="item.Name"></v-list-item-title>
                                        <!-- <v-list-item-subtitle v-text="item.Id"></v-list-item-subtitle> -->
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <!-- <v-list-item-action-text v-text="item.Id"></v-list-item-action-text> -->
                                        <v-icon v-if="!active" color="grey lighten-1">mdi-check-circle-outline</v-icon>
                                        <v-icon v-else color="blue darken-3">mdi-check-circle</v-icon>
                                    </v-list-item-action>
                                    </template>
                                </v-list-item>
                                <v-divider v-if="index < items.length - 1" :key="index"></v-divider>
                            </template>
                        </v-list-item-group>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn text @click="batchTypes.dialog = false">{{$t('app.btclose')}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-show="view === 'JSON_GENERATOR' && batchTypes.BatchTypes.length > 1 && !disableItem" color="error" text @click="confirmDelete">{{$t('app.btdelete')}}</v-btn>
                    <v-btn v-show="view === 'JSON_GENERATOR' && !disableItem" color="primary" text @click="createNewBatchType(true)">{{$t('app.btcopy')}}</v-btn>
                    <v-btn v-show="view === 'JSON_GENERATOR' && !disableItem" color="primary" text @click="createNewBatchType(false)">{{$t('app.btcreatenew')}}</v-btn>
                    <v-btn v-show="view === 'JSON_GENERATOR' && disableItem" color="primary" text @click="createNewBatchType(true)">{{$t('app.btcopy')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogNewbatch" persistent width="30%">
            <v-card>
                <v-card-title style="color: white" class="headline primary" primary-title>
                {{$t('app.batchtype')}}
                </v-card-title>
                <v-card-text>
                    <v-form ref="bTypeForm">
                        <v-text-field :label="$t('app.btname')" v-model="newBatchType.Name" :rules="[newBatchNameRule]" validate-on-blur required></v-text-field>
                        <v-text-field v-show="false" :label="$t('app.btid')" v-model="newBatchType.Id" readonly></v-text-field>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn text @click="dialogNewbatch = false">{{$t('app.btnewcancel')}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="saveNewbatchType">{{$t('app.btnewsave')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" persistent width="30%">
            <v-card>
                <v-card-title style="color: white" class="headline primary" primary-title>
                {{$t('app.batchtype')}}
                </v-card-title>
                <v-card-text style="color: red;">
                    <p><br/>{{ $t('app.btdeleteinfo').replace('{0}', this.batchTypes.Current.Name) }}</p>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn text @click="dialogDelete = false">{{$t('app.btnewcancel')}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click="deleteBatchType">{{$t('app.btdelete')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
/* eslint-disable no-unmodified-loop-condition */
/* eslint-disable */
import { BatchTypeModel } from '@/SolumaBatchTypes'
import DataTypes from '@/DataTypes'
export default {
    name: 'BatchTypesDialog',
    props: ['batchTypes', 'view'],
    data () {
        return {
            search: '',
            dialogDelete: false,
            dialogNewbatch: false,
            newBatchType: BatchTypeModel.getModel(),
            selectedIndex: 0
        }
    },
    watch: {
        'batchTypes.dialog': function(val) {
            console.log('Batch Types dialog', val)
            // if (this.batchTypes.BatchTypeJSON !== null) {
            //     this.selectedIndex = 0
            // } else {
                let active = 0
                this.items.forEach((item, index) => {
                    if (item.Selected) active = index
                })
                this.selectedIndex = active
            //}
        }
    },
    computed: {
        disableItem () {
            return this.batchTypes.BatchTypeJSON !== null
        },
        selected: {
            get: function () {
                /* if (this.batchTypes.BatchTypeJSON !== null) {
                    return 0
                } */
                let active = 0
                this.items.forEach((item, index) => {
                    if (item.Selected) active = index
                })
                return active
            },
            set: function (val) {
                console.log('selected new val', val)
            }
        },
        items () {
            const searchValue = this.search
            const arr = []
            if (this.batchTypes.BatchTypeJSON !== null) {
                arr.push(this.batchTypes.BatchTypeJSON)
            }
            arr.push(...this.batchTypes.BatchTypes)
            const filtered = arr.filter(bt => {
              if (searchValue.trim() === '') return true
              return bt.Name.toLowerCase().indexOf(searchValue.trim().toLowerCase()) >= 0
            })
            let ordered = filtered.sort((a, b) => {
              return a.Name.localeCompare(b.Name)
            })
            return ordered
        }
    },
    methods: {
        newBatchNameRule(v) {
          const dth = new DataTypes()
          if (dth.isNullOrEmpty(v)) return this.$i18n.t('app.btnameruleempty')
          const exist = this.batchTypes.BatchTypes.find(b => b.Name.toLowerCase() === v.toLowerCase())
          if (exist) return this.$i18n.t('app.btnameeixist') //
          return true
        },
        randomString (len) {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            let result = ""
            let charactersLength = characters.length;
            for ( var i = 0; i < len ; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result
        },
        confirmDelete () {
            this.dialogDelete = true
        },
        deleteBatchType () {
            const bType = this.batchTypes.Current
            const index = this.batchTypes.BatchTypes.findIndex(bt => bt.Id === bType.Id)
            let current = null
            if (this.batchTypes.BatchTypes.length - 1 > index) {
                current = this.batchTypes.BatchTypes[index + 1]
            } else {
                current = this.batchTypes.BatchTypes[0]
            }
            console.log(current.Name)
            this.batchTypes.BatchTypes.forEach(bt => { bt.Selected = false })
            current.Selected = true
            this.batchTypes.BatchTypes.splice(index, 1)
            this.selectedIndex = this.batchTypes.BatchTypes.indexOf(current)
            this.$emit('saveBatchType')
            this.dialogDelete = false
            window.setTimeout(() => {
                this.selectedIndex = this.batchTypes.BatchTypes.indexOf(current)
            }, 200)
        },
        changeType (item) {
            this.batchTypes.BatchTypes.forEach(bType => {
                if(item.Id === bType.Id) {
                    bType.Selected = true
                } else {
                    bType.Selected = false
                }
            })
            this.$emit('saveBatchType')
        },
        createNewBatchType (copy = false) {
            this.newBatchType = copy ? JSON.parse(JSON.stringify(this.batchTypes.Current)) : BatchTypeModel.getModel()
            this.newBatchType.Id = this.randomString(10)
            this.newBatchType.Name = copy ? this.newBatchType.Name + '(Copy)' : ''
            this.dialogNewbatch = true
        },
        saveNewbatchType () {
            if (!this.$refs.bTypeForm.validate()) return
            this.batchTypes.BatchTypes.push(this.newBatchType)
            this.newBatchType.Selected = false
            // this.batchTypes.BatchTypes.forEach(bType => { bType.Selected = false })
            // this.newBatchType.Selected = true
            // this.selectedIndex = this.batchTypes.BatchTypes.indexOf(this.newBatchType)
            this.$emit('saveBatchType')
            this.dialogNewbatch = false
        }
    }
}
</script>
